import { render } from "./TableBucket.vue?vue&type=template&id=413ea212"
import script from "./TableBucket.vue?vue&type=script&lang=js"
export * from "./TableBucket.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Gerente de TI\\Downloads\\temp\\JB\\new-project\\jb-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__